import type { ReactNode } from 'react'
import { Loader2 } from '@/lib/icons'
import { Button } from '@/components/ui/button'
import { Modal } from '@/components/ui/modal'

export interface ConfirmDialogProps {
  open: boolean
  title: string
  /** Oqibatni oddiy tilda tushuntiradi — ayniqsa `tone="danger"` uchun majburiy. */
  description: ReactNode
  confirmLabel: string
  cancelLabel?: string
  /** `danger` — qizil tugma, qaytarib bo'lmas/og'ir oqibatli amallar uchun (Bloklash). */
  tone?: 'primary' | 'danger'
  isLoading?: boolean
  /**
   * Server xatosi — mavjud bo'lsa tugmalar tepasida doimiy (yo'qolib qolmaydigan) matn
   * sifatida ko'rsatiladi. Bu oyna ochiq turgan holda muvaffaqiyatsiz tugagan amal uchun kerak
   * (masalan yakuniy tekshiruvni saqlash) — xato faqat pastdagi asosiy kartochkada ko'rinsa,
   * admin uni bu oyna ustida ko'rmay, "hech nima bo'lmadi" deb o'ylab qayta bosaveradi.
   */
  errorMessage?: string | null
  /** Tasdiq tugmasini o'chirib qo'yish (masalan majburiy maydon to'ldirilmagan). */
  confirmDisabled?: boolean
  onConfirm: () => void
  onCancel: () => void
}

/**
 * Umumiy tasdiqlash oynasi — `docs/04-ui-ux.md`: "Xavfli amallar... doim tasdiq oynasi bilan".
 * Tasdiqlash va Bloklash ikkalasi ham shu orqali o'tadi, faqat `tone` va matn farq qiladi.
 */
export function ConfirmDialog({
  open,
  title,
  description,
  confirmLabel,
  cancelLabel = 'Bekor qilish',
  tone = 'primary',
  isLoading = false,
  errorMessage,
  confirmDisabled = false,
  onConfirm,
  onCancel,
}: ConfirmDialogProps) {
  return (
    <Modal open={open} onClose={onCancel} ariaLabel={title} size="compact" zIndex={50}>
      <div className="flex flex-col gap-4 p-5">
        <h2 className="text-base font-semibold">{title}</h2>
        <div className="text-sm text-app-hint">{description}</div>
        {errorMessage && (
          <p className="text-xs font-medium text-stage-rejected-text">{errorMessage}</p>
        )}
        <div className="flex justify-end gap-2 pt-1">
          <Button variant="secondary" onClick={onCancel} disabled={isLoading}>
            {cancelLabel}
          </Button>
          <Button
            variant={tone === 'danger' ? 'danger' : 'primary'}
            onClick={onConfirm}
            disabled={isLoading || confirmDisabled}
          >
            {isLoading && <Loader2 size={16} className="animate-spin" aria-hidden="true" />}
            {confirmLabel}
          </Button>
        </div>
      </div>
    </Modal>
  )
}
